import { useState } from 'react';

import { useFocusReturn } from './use-focus-return';

/**
 * Open and closed state for a composer, with focus handled: closing it puts
 * focus back on the button that opened it.
 */
export function useComposerState() {
  const [composing, setComposing] = useState(false);
  const addButton = useFocusReturn();

  return {
    composing,
    addButtonRef: addButton.ref,
    open: () => setComposing(true),
    close: () => {
      setComposing(false);
      addButton.request();
    },
  };
}
